import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-177">
      {label && <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-178">
          {label}
        </label>}
      <textarea className={`w-full px-4 py-3 bg-white border-2 border-slate-200 rounded-lg focus:outline-none focus:border-orange-500 transition-colors resize-none ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-179" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-180">{error}</p>}
    </div>;
}